<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfoC.data"
        :field-list="filterInfoC.filterList"
        :list-type-info="listTypeInfoC"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
        @handleSuggestions="handleSuggestions"
        @handleFocus="handleFocus"
        @handleInput="handleInput"
        @handleEvent="handleEvent"
        @handleSelect="handleSelect"
      ></e-search>
    </div>

    <div class="container">
      <eTableList
        :table-data="tableData"
        :table-label="tableLabelC"
        :row-key="rowKey"
      >
        <template #indexSlot="slot">
          <div class="flex-center-center">{{ slot.scope.$index + 1 }}</div>
        </template>

        <template #roleList="slot">
          <div
            v-if="slot.scope.row.roleList.length > 1"
            style="color: #2587ff; cursor: pointer"
          >
            <eui-btn
              type="link"
              size="12"
              @click="viewRole(slot.scope.row.roleList)"
              >共计{{ slot.scope.row.roleList.length }}个角色</eui-btn
            >
          </div>
          <div v-else>{{ slot.scope.row.roleList[0].roleName }}</div>
        </template>
        <template #optionsSlot="slot">
          <eui-btn
            color="#0064c8,#004898,#004898"
            type="link"
            size="12"
            @click="handlePass(slot.scope.row)"
            >审核通过</eui-btn
          >
          <eui-btn
            type="link"
            style="color: red"
            size="12"
            @click="handleRefuse(slot.scope.row)"
            >审核拒绝</eui-btn
          >
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.pageStart"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <ViewDialog
      :table-list="tableList"
      :visible="viewRoleDialogShow"
      @close="closeCheckRole"
    ></ViewDialog>
    <RefuseDialog ref="refuseDialog" @getList="getList"></RefuseDialog>
  </div>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list';
import eSearch from '@/modules/projectA/components/common/e-search';
import _ from 'lodash';
import ViewDialog from './components/viewRoleDialog.vue';
import RefuseDialog from './components/refuseDialog.vue';
import Api from '../../api/authority';
import { roleApply } from './roleApply';

export default {
  name: 'RoleApplyCheck',
  components: {
    ViewDialog,
    RefuseDialog,
    eTableList,
    eSearch,
  },
  props: {},
  data() {
    return {
      roleApply,
      query: {
        createByName: null,
        memberName: null,
        roleName: null,
      },
      filterInfoC: roleApply.filterInfoC,
      listTypeInfoC: roleApply.listTypeInfoC,
      tableData: [],
      tableLabelC: roleApply.tableLabelC,
      productTagPage: {
        pageStart: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      roleData: {},
      rowKey: 'roleId',
      selectionData: [],
      tableList: [],
      viewRoleDialogShow: false,
      refuseDialogShow: false,
      category: {},
      labelName: '',
      titleName: '',
      cloneTableData: [],
      bhroleNameList: [],
    };
  },
  computed: {},
  created() {
    this.getList();
  },
  methods: {
    handleEvent(ev) {
      this.category = ev;
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleFocus(row) {
      this.labelName = row.item.label;
      this.titleName = row.item.value;
    },
    handleInput(row) {
      if (row === '') {
        this.seekFlag = false;
        this.tableData = [...this.cloneTableData];
      }
    },
    // 去重
    deWeightThree(arr) {
      const map = new Map();
      // eslint-disable-next-line no-restricted-syntax
      for (const item of arr) {
        if (!map.has(item.value)) {
          map.set(item.value, item);
        }
      }
      return [...map.values()];
    },
    // 搜索提示框
    handleSuggestions(val) {
      const { queryString, cb } = val;
      this.roleList = [];
      if (this.tableData?.length > 0 && this.tableData !== undefined) {
        // eslint-disable-next-line no-restricted-syntax
        for (const i of this.tableData) {
          // eslint-disable-next-line no-restricted-syntax
          for (const j of i.roleList) {
            // eslint-disable-next-line no-restricted-syntax
            for (const k in j) {
              if (k === 'roleName') {
                const obj = {
                  value: j.roleName,
                };
                this.roleList.push(obj);
              }
            }
          }
        }
      }

      if (this.labelName === '包含角色') {
        const results1 = queryString
          ? this.roleList.filter(this.createFilter(queryString))
          : this.roleList;
        cb(this.deWeightThree(results1));
      }
    },
    handleSelect(ev) {
      // 只有选择的才能搜索
      this.currentPage = 1;
      this.seekFlag = true;
      if (this.labelName === '包含角色') {
        const arr1 = [];
        // eslint-disable-next-line array-callback-return
        this.cloneTableData.map((item) => {
          // eslint-disable-next-line array-callback-return
          item.roleList.map((ktem) => {
            if (ktem.roleName === ev.value) {
              arr1.push(item);
            }
          });
        });
        this.tableData = arr1;
        // this.handleQuery({ roleList: ev.value });
      }
    },
    viewRole(roleList) {
      this.queryByRoleIdList(roleList);
    },
    queryByRoleIdList(roleList) {
      const params = {
        roleIdList: roleList.map((item) => item.roleId),
      };
      Api.queryByRoleIdList(params).then((res) => {
        if (res.code === '200') {
          this.tableList = res.data;
          this.viewRoleDialogShow = true;
        }
      });
    },
    closeCheckRole() {
      this.viewRoleDialogShow = false;
      this.refuseDialogShow = false;
    },
    // 搜索
    handleQuery(val) {
      console.log(val);
      this.query = val;
      if (val.roleList) {
        this.query.roleName = val.roleList;
      }
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getList();
    },
    // 重置
    handleReset() {
      this.query = {
        createByName: null,
        memberName: null,
        roleName: null,
      };
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getList();
    },
    // 通过
    handlePass(row) {
      // console.log(row.roleList.map((item)=> item.roleName))
      // const { companyId } = JSON.parse(localStorage.getItem('USERINFO'));
      this.$confirm(
        `您正在尝试审核通过一条角色申请，继续操作会将“${row.roleList.map(
          (item) => item.roleName
        )}”角色 授予 ${row.createByName}（${
          row.memberName
        }），请确认角色与授予对象是否正确。<br/>如需修改可进入“运营中心-用户-员工管理”中，使用“分配角色”功能进行调整。<br/>继续操作将完成此次权限授予，是否继续？`,
        '审核通过确认',
        {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          const params = {};
          params.applyId = row.applyId;
          Api.rolePass(params).then((res) => {
            if (res.code === '200') {
              this.$message.success('审批通过');
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    // 拒绝
    handleRefuse(row) {
      console.log(row);
      const object = this.$refs.refuseDialog;
      object.initData(row);
    },
    // 获得列表
    getList() {
      const params = this.query;
      delete params.roleList;
      // params.companyId = JSON.parse(localStorage.getItem('USERINFO')).companyId;
      params.pageSize = this.productTagPage.pageSize;
      params.pageStart = this.productTagPage.pageStart;

      Api.queryNeedApprovePage(params).then((res) => {
        this.tableData = res.data?.list;
        this.cloneTableData = _.cloneDeep(this.tableData);
        this.productTagPage.pageTotal = res.data.total;
      });
    },
    // 更改页码
    handleCurrentChange(val) {
      this.productTagPage.pageStart = val;
      this.getList();
    },

    // 更改条数
    handleSizeChange(val) {
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .text-box {
    padding: 11px 10px;
    background: #f4f7ff;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    line-height: 24px;
    color: #666;
    margin-top: 10px;
    text-align: center;
  }
  .button-box {
    padding-bottom: 10px;
    margin-top: 10px;
  }
}
</style>
